import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Col, Divider, Row, Space, Spin } from 'antd'
import { isEmpty } from 'lodash'

import { UpdateDataText } from '../../../core/components/sections'

import {
  HistoryLink,
  NodeBreadcrumbs,
} from '../../../common/components/sections'
import { StyledPageSubTitle } from '../../../common/components/styled'
import { EVENT_METADATA_TYPES, METADATA_TYPES } from '../../../common/constants'
import { showErrorNotification } from '../../../common/helpers'
import { useDocumentTitle } from '../../../common/hooks'

import { renderAwardEvent } from '../../helpers'
import { useAwardQuery } from '../../hooks'
import { AwardSimpleDetailsForm } from '../forms'

const AwardDetailsPage = () => {
  const { id } = useParams()

  const {
    isLoading: isFetchLoading,
    error: fetchError,
    data,
  } = useAwardQuery(id)

  useDocumentTitle(`${data?.name || 'Loading Award...'}`)

  useEffect(() => {
    if (fetchError) {
      showErrorNotification({
        title: 'Award error',
        description: fetchError,
      })
    }
  }, [fetchError])

  return isFetchLoading || isEmpty(data) ? (
    <Spin />
  ) : (
    <>
      <StyledPageSubTitle>
        <Row justify="space-between">
          <Col span={12}>
            <NodeBreadcrumbs
              metadataType={METADATA_TYPES.AWARDS}
              idPath={data.node.idPath}
              namePath={data.node.namePath}
            />
          </Col>

          <Space>
            <UpdateDataText
              updatedAt={data.updatedAt}
              updatedBy={data.updatedBy?.name}
            />

            <HistoryLink
              renderEvent={renderAwardEvent}
              entityId={id}
              eventMetadataTypes={[EVENT_METADATA_TYPES.AWARD]}
            />
          </Space>
        </Row>
      </StyledPageSubTitle>
      <AwardSimpleDetailsForm
        id={data.id}
        name={data.name}
        description={data.description}
        position={data.position}
        maxPosition={data.maxPosition}
      />
      <Divider />
    </>
  )
}

export default AwardDetailsPage
